<template>
    <div class="my-connections-list-filter">
        <form-wrapper :isSubmittable="false">
            <form-row>
                <div class="filtering-options-left">
                    <form-cell>
                        <checkbox-input
                            :label="$t('elements.practice_member_filter.all')"
                            :value="checked('All')"
                            @change="filtersChanged('All')"
                        ></checkbox-input>
                    </form-cell>

                    <form-cell>
                        <checkbox-input
                            :label="$t('elements.practice_member_filter.physicians')"
                            :value="checked('Physician')"
                            @change="filtersChanged('Physician')"
                        ></checkbox-input>
                    </form-cell>

                    <form-cell>
                        <checkbox-input
                            :label="$t('elements.practice_member_filter.pending_approval')"
                            :value="checked('PendingApproval')"
                            @change="filtersChanged('PendingApproval')"
                        ></checkbox-input>
                    </form-cell>
                </div>
                <form-cell class="orderby-cell">
                    <div class="filtering-options-right">
                        <select-field
                            :label="$t('elements.practice_member_filter.order_by')"
                            :options="data.orderByItems"
                            :formData="data"
                            valuePath="currentOrderBy"
                            @change="orderByChanged"
                        ></select-field>
                    </div>
                </form-cell>
            </form-row>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],
        components: {},
        props: {
            filter: { type: String, default: 'All' },
            orderBy: { type: String, default: 'firstName asc,lastName asc' },
        },
        data() {
            return {
                data: {
                    currentFilter: this.filter,
                    currentOrderBy: this.orderBy,
                    orderByItems: [
                        { label: this.$t('common.order_by.a_to_z'), value: 'firstName asc,lastName asc' },
                        { label: this.$t('common.order_by.z_to_a'), value: 'firstName desc,lastName asc' },
                        { label: this.$t('common.order_by.created_ascending'), value: 'createdDate asc' },
                        { label: this.$t('common.order_by.created_descending'), value: 'createdDate desc' },
                    ],
                },
            }
        },
        methods: {
            filtersChanged(selectedFilter) {
                this.data.currentFilter = selectedFilter

                this.$emit('filter-changed', {
                    filter: this.data.currentFilter,
                    orderBy: this.data.currentOrderBy,
                })
            },
            orderByChanged(newOrderBy) {
                this.data.currentOrderBy = newOrderBy.value

                this.$emit('filter-changed', {
                    filter: this.data.currentFilter,
                    orderBy: this.data.currentOrderBy,
                })
            },
            checked(value) {
                return value === this.data.currentFilter
            },
        },
    }
</script>
